import { render, staticRenderFns } from "./RankingCardWinnerParts.vue?vue&type=template&id=2cafeee0&scoped=true"
import script from "./RankingCardWinnerParts.vue?vue&type=script&lang=ts"
export * from "./RankingCardWinnerParts.vue?vue&type=script&lang=ts"
import style0 from "./RankingCardWinnerParts.vue?vue&type=style&index=0&id=2cafeee0&prod&lang=scss&scoped=true"
import style1 from "./RankingCardWinnerParts.vue?vue&type=style&index=1&id=2cafeee0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cafeee0",
  null
  
)

export default component.exports